import { WORKER_AVERAGE_SUCCESS, WORKER_AVERAGE_REQUEST, WORKER_AVERAGE_REQUEST_FAILURE, SET_PRODUCTION_TRANSACTION_ID,
  SET_WORKER_AVERAGE_SUMMURY } from "../types";

const initialState = {
  workerAverages: [],
  workerSummary: [],
  prodTransId: null,
  loading: false,
  error: null,
};

const workerAverageReducer = (state = initialState, action) => {
  switch (action.type) {
    case WORKER_AVERAGE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case WORKER_AVERAGE_SUCCESS: {
      return {
        ...state,
        workerAverages: [...action.payload],
        loading: false,
        error: null
      }
    }
    case SET_PRODUCTION_TRANSACTION_ID: {
      return {
        ...state,
        prodTransId: action.payload,
      }
    }
    case SET_WORKER_AVERAGE_SUMMURY: {
      return {
        ...state,
        workerSummary: [...action.payload],
        loading: false,
        error: null
      }
    }
    case WORKER_AVERAGE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default workerAverageReducer;